// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8dL5v","name":"styles_name__39kaZ","phone":"styles_phone__1v8W9"};